module.exports = __webpack_public_path__ + "components/advertise-markets/static/guest-with-ab-4384021de8713c5f0e8c54937dc4406c.jpg";